<template>
    <div class="backend-container deal-share analytics-container">
        <BackendHeader />
        <br />
        <br />
        <button @click="refreshIframe">REFRESH</button>
        <iframe src="/ClickyAnalytics" ref="iframe"></iframe>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import BackendHeader from '@/components/BackendHeader.vue'

export default defineComponent({
    name: "Analytics",
    components: {
        BackendHeader
    },
    setup() {
        const iframe = ref<HTMLIFrameElement | null>(null)

        const refreshIframe = () => {
            iframe.value?.contentWindow?.location.reload()
        }

        return {
            iframe,
            refreshIframe
        }
    }
})
</script>

<style>
    iframe {
        width: 250px;
        height: 300px;
        border: 0;
    }

    .analytics-container{
        width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>